import { render, staticRenderFns } from "./CountSection.vue?vue&type=template&id=071cd955&scoped=true"
import script from "./CountSection.vue?vue&type=script&lang=js"
export * from "./CountSection.vue?vue&type=script&lang=js"
import style0 from "./CountSection.vue?vue&type=style&index=0&id=071cd955&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071cd955",
  null
  
)

export default component.exports